module.exports = {["template-constructor-helpers-upload-input"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n	<input class="rm-upload-input"\n	       type="file"\n	       name="upload"\n	       data-url="/api/upload/" />\n\n';
}
return __p;
},}